import styled from "styled-components";
import customMedia from "../../config/breakpoints";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin-bottom: 48px;

  ${customMedia.lessThan("desktop")`
    margin-bottom: 40px;
  `}

  ${customMedia.lessThan("tablet")`
      align-items:center;
      margin-bottom: 24px;
    `}
`;

export const LeftContainer = styled.div`
  margin-right: 50px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const RightContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 50px;
  gap: 8px;

  ${customMedia.lessThan("tablet")`
    display:none;
`}
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 200px;
  align-items: center;
  justify-content: center;
`;

export const ExpertiseContainer = styled.div`
  display: flex;
  gap: 8px;
  margin: 40px 0px;
  flex-wrap: wrap;
  justify-content: center;

  ${customMedia.lessThan("tablet")`
    flex-direction:column;
    width:100%;
  `}
`;

export const DividerContainer = styled.div`
  margin-top: 40px;
  width: 100%;
`;

export const UrgencyContainer = styled.div`
  margin-top: 80px;
  width: 100%;
`;

export const SearBarContainer = styled.div`
  width: 100%;
  margin: 24px 0 0 0;
`;

export const ResultsBlocContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 56px 0;
  width: 100%;
`;

export const StepCardContainer = styled.div`
  width: 100%;
`;
